module.exports = __webpack_public_path__ + "static/media/work.597e5c0b.svg";